export { imp };

function imp($element, title) {
  if ($element.href &&
    $element.href.length > 0 &&
    isOutboundLink($element.href)
  ) {
    // アウトバウンドリンクの計測は自動でされるため gtm-click, data-gtm-title はつけない
    $element.classList.add('gtm-impression');
  } else {
    $element.classList.add('gtm-click', 'gtm-impression');
    $element.dataset.gtmTitle = title;
  }
  return $element;
}

function isOutboundLink(url) {
  if (url.startsWith('http') || url.startsWith('//')) {
    const urlA = new URL(url);
    const urlB = new URL(window.location);
    if (urlA.origin !== urlB.origin) {
      return true;
    }
  }
  return false;
}
